import * as Yup from "yup";

// login User
export const loginSchema = Yup.object({
    email: Yup.string().required('Email is required').email(),
    password: Yup.string().required('Password is required'),
});

// Forgot Email Verification Schema
export const emailSchema = Yup.object({
    email: Yup.string().required('Email is required').email(),
});

export const passwordSchema = Yup.object({
    newpassword: Yup.string().required('newpassword is required'),
});

export const validateProfileData = Yup.object({
    profileImage: Yup.string().nullable(),
    firstName: Yup.string().nullable(),
    lastName: Yup.string().nullable(),
});

// Change password schema
export const changePasswordSchema = Yup.object({
    currentPassword: Yup.string().required('Current password is required'),
    newPassword: Yup.string()
        .min(8, 'Password must be at least 8 characters')
        .max(128, 'Password cannot exceed 128 characters')
        .required('New password is required'),
    confirmPassword: Yup.string()
        .oneOf([Yup.ref('newPassword'), null], 'Passwords must match')
        .required('Please confirm your password'),
});

// Reset password schema (code-based)
export const resetPasswordSchema = Yup.object({
    code: Yup.string()
        .length(6, 'Verification code must be 6 digits')
        .matches(/^[0-9]+$/, 'Verification code must contain only digits')
        .required('Verification code is required'),
    password: Yup.string()
        .min(8, 'Password must be at least 8 characters')
        .max(128, 'Password cannot exceed 128 characters')
        .required('Password is required'),
    confirmPassword: Yup.string()
        .oneOf([Yup.ref('password'), null], 'Passwords must match')
        .required('Please confirm your password'),
});